module.exports = __webpack_public_path__ + "static/blog50-231319e06ad2ce52c58b12292e916202.png";